export interface FirebaseEmulatorModeInput {
  production: boolean;
  search: string;
  storedPreference: string | null;
}

export interface FirebaseEmulatorAutoSignInInput {
  hostname: string;
  search: string;
  useFirebaseEmulators: boolean;
}

export function shouldUseFirebaseEmulators({
  production,
  search,
  storedPreference,
}: FirebaseEmulatorModeInput): boolean {
  const params = new URLSearchParams(search);
  if (params.has('live')) return false;
  if (params.has('emulate')) return true;
  if (storedPreference === 'true') return true;
  return !production;
}

export function shouldInitializeRemoteTelemetry(input: FirebaseEmulatorModeInput): boolean {
  return !shouldUseFirebaseEmulators(input);
}

export function shouldAutoSignInToFirebaseEmulator({
  hostname,
  search,
  useFirebaseEmulators,
}: FirebaseEmulatorAutoSignInInput): boolean {
  if (!useFirebaseEmulators) return false;
  if (hostname !== 'localhost') return false;
  return !new URLSearchParams(search).has('manualLogin');
}
